<ul>
  <li *ngFor="let title of roleTitles | async; last as isLast">
    <ub-label *ngIf="isLast" [text]="title"></ub-label>
    <ub-label *ngIf="!isLast" [text]="title + ', '"></ub-label>
  </li>
</ul>
